import { Button, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import InsumosBtnLoading from "./BtnLoading";

export default function InsumosPedidoTabelaProdutos({ id_pedido, filtrosDados, pedido, produtos, btnIdClick, unidadesOptions, produtosOptions, onChange, onSave, loading }: iProps) {
    let edicao_desabilitada = false
    if (Object.values(pedido).length > 0) {
        edicao_desabilitada = pedido.id_status.id_status === 1 ? false : true
    }

    function handleChange(idx: number, coluna: "qtd" | "prod" | "unid", value: any) {
        if (idx > produtos.length) {
            return
        }
        let produtosAux: any[] = []
        for (let id in produtos) {
            let produto = {
                id: produtos[id].id,
                id_pedido: id_pedido,
                id_produto: produtos[id].id_produto,
                id_unidade: produtos[id].id_unidade,
                qtd: produtos[id].qtd,
            }
            if (Number(id) === idx) {
                switch (coluna) {
                    case "qtd":
                        let qtd = Number(value)
                        if (qtd <= 0) { qtd = 1 }
                        if (qtd > 50) { qtd = 50 }
                        produto["qtd"] = qtd
                        break;
                    case "prod":
                        const ID_PRODUTO = Number(value)
                        produto["id_produto"] = ID_PRODUTO
                        const produtosEncontrados = filtrosDados.produtos.filter((reg:any) => reg.id_produto === ID_PRODUTO)
                        if (produtosEncontrados.length > 0) { produto["id_unidade"] = produtosEncontrados[0].id_unidade_padrao.id_unidade }
                        break;
                    case "unid":
                        produto["id_unidade"] = Number(value)
                        break;
                }
            }
            produtosAux.push(produto)
        }
        onChange(produtosAux)
        // dispatch(atualizarProdutos({ produtos: produtosAux }))
    }

    function getLabel(option: "prod" | "unid", id: number): string {
        let options = []
        if (option === "prod") {
            options = produtosOptions.filter(reg => Number(reg.value) === id)
        }
        if (option === "unid") {
            options = unidadesOptions.filter(reg => Number(reg.value) === id)
        }
        if (options.length > 0) {
            return options[0].label
        }
        return `${option}-${id}`
    }

    function handleRemove(idx: number) {
        let localProdutosAux: any[] = []
        for (let id in produtos) {
            if (Number(id) === idx) {
                continue
            }
            localProdutosAux.push(produtos[id])
        }
        onChange(localProdutosAux)
        // dispatch(atualizarProdutos({ produtos: localProdutosAux }))
    }

    function handleAdd(event: any) {
        let produto_novo = {
            id: null,
            id_pedido: id_pedido,
            id_produto: 0,
            id_unidade: 0,
            qtd: 1,
        }
        let localProdutosAux: any[] = []
        for (let reg of produtos) { localProdutosAux.push(reg) }
        localProdutosAux.push(produto_novo)
        onChange(localProdutosAux)
        // dispatch(atualizarProdutos({ produtos: localProdutosAux }))
    }

    return (
        <div>
            {
                produtos.map((prod, idx, arr) => {
                    const defaultValue = { value: 0, label: "Não Selecionado" }
                    let qtd = prod.qtd === 0 ? 1 : prod.qtd
                    let produto = prod.id_produto === 0 ? defaultValue : { value: prod.id_produto, label: getLabel("prod", prod.id_produto) }
                    let unidade = prod.id_unidade === 0 ? defaultValue : { value: prod.id_unidade, label: getLabel("unid", prod.id_unidade) }
                    return (
                        <div key={idx} style={{ width: "100%" }}>
                            <Row className="mb-15-forms">
                                <Col className="col-2">
                                    <Form.Group>
                                        { idx === 0 && <Form.Label>Quantidade:</Form.Label> }
                                        <Form.Control name={`${idx}-qtd`} type="number" disabled={edicao_desabilitada} id={`${idx}-qtd`} placeholder="" value={qtd} onChange={
                                            (event) => {
                                                handleChange(idx, "qtd", event.target.value)
                                            }
                                        } />
                                        <Form.Control.Feedback type="invalid">
                                            Informe a quantidade!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col className="col-2">
                                    <Form.Group style={{ width: "100%" }}>
                                        { idx === 0 && <Form.Label>Unidade:</Form.Label> }
                                        <Select name='id_unidade' id='id_unidade' isDisabled={edicao_desabilitada} options={unidadesOptions} value={unidade} placeholder="Selecione" onChange={
                                            (choice: any) => {
                                                handleChange(idx, "unid", choice.value)
                                            }
                                        } styles={customStyleSelect} />
                                        <Form.Control name={`${idx}-id_unidade_aux`} type="text" id={`${idx}-id_unidade_aux`} placeholder="" style={{ display: "none" }} />
                                        <Form.Control.Feedback type="invalid">
                                            Informe a Unidade!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col className='col-5'>
                                    <Form.Group style={{ width: "100%" }}>
                                        { idx === 0 && <Form.Label>Produto:</Form.Label> }
                                        <Select name={`${idx}-id_produto`} id={`${idx}-id_produto`} isDisabled={edicao_desabilitada} options={produtosOptions} value={produto} placeholder="Selecione" onChange={
                                            (choice: any) => {
                                                handleChange(idx, "prod", choice.value)
                                            }
                                        } styles={customStyleSelect} />
                                        <Form.Control name={`${idx}-id_produto_aux`} type="text" id={`${idx}-id_produto_aux`} placeholder="" style={{ display: "none" }} />
                                        <Form.Control.Feedback type="invalid">
                                            Informe o Produto!
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                {
                                    !edicao_desabilitada &&
                                    <Col className="col-1">
                                        { idx === 0 && <div><Form.Label>&nbsp;</Form.Label><br></br></div> }
                                        <Button variant="secondary" onClick={() => handleRemove(idx)} >Remover</Button>
                                    </Col>
                                }

                            </Row>
                        </div>
                    )
                })
            }
            {
                !edicao_desabilitada &&
                <div>
                    { Object.values(pedido).length > 0 && <Button id="btnSalvarListaProdutos" variant="success" onClick={() => { onSave() }} style={{ marginRight: "10px" }} ><InsumosBtnLoading btnId="btnSalvarListaProdutos" btnIdClick={btnIdClick} loading={loading} /> Salvar</Button> }
                    <Button id="btnAdicionarProdutoLista" variant="primary" onClick={handleAdd} style={{ marginRight: "10px" }} >Adicionar Produto</Button>
                </div>
            }
        </div>
    )
}
interface iProps {
    id_pedido: number | null
    filtrosDados: any
    pedido: any
    produtos: any[]
    btnIdClick: string
    unidadesOptions: any[]
    produtosOptions: any[]
    onChange: any
    onSave: any
    loading: boolean
}

const customStyleSelect = {
    control: (baseStyles: any, state: any) => ({
        ...baseStyles,
        borderColor: "#dee2e6",
        backgroundColor: state.isDisabled ? "#E9ECEF" : "white",
    }),
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "black" : "black",
    }),
}
